/**
 * Image URL utility functions
 * Handles both S3 URLs and local API paths
 */

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Returns the correct image URL based on whether it's an S3 URL or local path
 * @param {string} url - The image URL (could be S3 URL or local path)
 * @returns {string|undefined} - The full image URL
 */
export const getImageUrl = (url) => {
  if (!url) return undefined;
  // If it's already a full URL (S3 or other external), use it as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Otherwise, prepend the API URL for local paths
  return `${API}${url}`;
};

/**
 * Returns the correct profile picture URL
 * @param {object} user - User object with profile_picture property
 * @returns {string|undefined} - The profile picture URL or undefined
 */
export const getProfilePictureUrl = (user) => {
  return getImageUrl(user?.profile_picture);
};
